import { Accordion } from "@made-people/blueprint-accordion";
import { PlusIcon } from "../../../assets/icons/Plus";
import { MinusIcon } from "../../../assets/icons/Minus";
import { useTranslate } from "@made-people/grease-translations";
import { type TechnicalFeatureItem } from "../../../hooks/use-technical-features-settings";

export const ComfortAccordion = ({
  items,
}: {
  items: TechnicalFeatureItem[];
}) => {
  const translate = useTranslate();
  if (!items?.length) return null;

  return (
    <div className="bg-surface-1 rounded-md p-6 col-start-1 col-span-12 lg:col-span-6 lg:row-start-6 mt-4 lg:mt-6 mb-2">
      <h2 className="text-heading-md text-center lg:text-left lg:text-heading-lg mb-3">
        {translate("PDP_Comfort_Accordion_Heading")}
      </h2>
      <Accordion
        icons={{
          open: <PlusIcon className="w-3 h-3" />,
          close: <MinusIcon className="w-3 h-3" />,
        }}
        layout={{ spacing: { applySpacing: "false" } }}
        items={items.map((item) => ({
          content: {
            value: item.heading,
            trigger: item.heading,
            content: item.body,
            ...(item.icon?.filename && {
              icon: {
                initial: {
                  src: item.icon.filename,
                  alt: item.icon.alt || item.heading,
                },
              },
            }),
          },
        }))}
      />
    </div>
  );
};
